import { useTranslation } from "react-i18next";

import { getCurrentScreen } from "@auth0/auth0-acul-js";

import { getScreenComponent } from "@/utils/screen/screenLoader";

/**
 * Production Screen Manager
 * Reads the current screen from the Universal Login context.
 *
 * Uses @auth0/auth0-acul-js, not the @auth0/auth0-acul-react root: App imports
 * this module statically, also in dev, and the acul-react root evaluates every
 * screen's SDK module on import, which throws before the dev context panel has
 * set up a Universal Login context.
 */
export default function ProdScreenManager() {
  const { t } = useTranslation();
  const screenName = getCurrentScreen() ?? undefined;
  const ScreenComponent = getScreenComponent(screenName);

  if (!screenName) {
    return null;
  }

  if (ScreenComponent) {
    // eslint-disable-next-line react-hooks/static-components
    return <ScreenComponent key={screenName} />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center p-8">
        <p className="text-lg text-gray-600">
          {t("common.screenNotImplemented", { screenName })}
        </p>
      </div>
    </div>
  );
}
